<template>
  <div>
    <span class="icon property"></span>
    <span class="title">Gebäude<br class="mobile-break">massnahmen</span>
    <p>An Gebäude gebundene Massnahmen:</p>
    <ul>
      <li>Gebäudemodernisierung mit Konzept</li>
      <li>Erneuern oder neu bauen</li>
      <li>Heizung ersetzen</li>
      <li>thermische Solaranlagen</li>
      <li>Wärmenetzprojekte</li>
    </ul>
    <property-selection :isModalEdit="isModalEdit"/>
    <type-selection v-if="propertyId && propertyCommunityId" :isModalEdit="isModalEdit"/>
    <b-alert v-if="propertyId && !propertyCommunityId" variant="danger" show>
      Dieses Gebäude befindet sich nicht im Kanton St. Gallen.
    </b-alert>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PropertySelection from '@/components/application/Intro/PropertyActions/PropertySelection.vue'
  import TypeSelection from '@/components/application/Intro/PropertyActions/TypeSelection.vue'

  export default {
    data: () => ({
      isModalEdit: ''
    }),
    created () {
      this.isModalEdit = this.$route.params.modalMethod === 'bearbeiten'
    },
    computed: {
      ...mapState({
        propertyId: state => state.application.createApplication.propertyId,
        propertyCommunityId: state => state.application.createApplication.propertyCommunityId
      })
    },
    components: {
      PropertySelection,
      TypeSelection
    }
  }
</script>

<style lang="scss">
 .title br.mobile-break {
    display: block !important;

    @include media-breakpoint-up(sm) {
      display: none !important;
    }
 }
</style>
